import { useNode } from "@craftjs/core";
import { FormControl, FormControlLabel, FormGroup, InputLabel, MenuItem, Select, Slider, Stack, Switch, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { useState } from "react";
import ColorSettings from "./ColorSettings";
import useResponsiveValues from "../hooks/useResponsiveValues";

export type TransitionFlip = "transitionTopFlipVertical" | "transitionBottomFlipVertical" | "transitionTopFlipHorizontal" | "transitionBootomFlipHorizontal";

const SectionTransitionSetting = () => {
  const [position, setPosition] = useState<"Top" | "Bottom">("Bottom");
  const responsive = useResponsiveValues();

  const {
    props,
    actions: { setProp },
  } = useNode((node) => ({
    props: node.data.props,
  }));

  const handleChangeShape = (e: { target: { value: string } }) => {
    const value = e.target.value;

    setProp((props: { transitionTop?: string; transitionBottom?: string }) => {
      props[`transition${position}`] = value === "none" ? undefined : value;
      return props;
    });
  };

  const handleChangeFlip = (e: { target: { checked: boolean; name: TransitionFlip } }) => {
    const target = e.target.name;
    const checked = e.target.checked;
    setProp((props: Partial<Record<TransitionFlip, boolean>>) => {
      props[target] = checked;
      return props;
    });
  };

  return (
    <Stack spacing={2}>
      <FormControl fullWidth={true}>
        <ToggleButtonGroup
          color="primary"
          value={position}
          exclusive
          onChange={(_, value) => {
            return setPosition(value);
          }}
          fullWidth
          size="small"
        >
          <ToggleButton size="small" value="Top">
            Top
          </ToggleButton>
          <ToggleButton size="small" value="Bottom">
            Bottom
          </ToggleButton>
        </ToggleButtonGroup>
      </FormControl>

      <Stack spacing={2}>
        <Stack direction="row" spacing={2}>
          <Stack flex={1}>
            <FormControl size="small" fullWidth>
              <InputLabel id="transition-setting">Forma</InputLabel>
              <Select label="Variante" labelId="transition-setting" value={position === "Top" ? props.transitionTop : props.transitionBottom} onChange={handleChangeShape}>
                <MenuItem value="none">Ninguno</MenuItem>
                <MenuItem value="waves-1">Olas 1</MenuItem>
                <MenuItem value="waves-2">Olas 2</MenuItem>
                <MenuItem value="triangles-1">Triángulos 1</MenuItem>
                <MenuItem value="zig-zag">ZigZap</MenuItem>
                <MenuItem value="zig-zag-rounded">ZigZap Redondeado</MenuItem>
                <MenuItem value="arc-1">Arc 1</MenuItem>
                <MenuItem value="arc-inverted-1">Arc Inverted 1</MenuItem>
                <MenuItem value="diagonal-1">Diagonal</MenuItem>
              </Select>
            </FormControl>
          </Stack>
          <Stack flex={1}>
            <FormControl component="fieldset" variant="standard">
              <FormGroup>
                <Stack direction="row" spacing={2}>
                  <FormControlLabel
                    label="Vertical"
                    control={
                      <Switch
                        name={position === "Top" ? "transitionTopFlipVertical" : "transitionBottomFlipVertical"}
                        checked={position === "Top" ? props.transitionTopFlipVertical : props.transitionBottomFlipVertical}
                        onChange={handleChangeFlip}
                      />
                    }
                  />
                  <FormControlLabel
                    label="Horizontal"
                    control={
                      <Switch
                        name={position === "Top" ? "transitionTopFlipHorizontal" : "transitionBootomFlipHorizontal"}
                        checked={position === "Top" ? props.transitionTopFlipHorizontal : props.transitionBootomFlipHorizontal}
                        onChange={handleChangeFlip}
                      />
                    }
                  />
                </Stack>
              </FormGroup>
            </FormControl>
          </Stack>
        </Stack>

        <Slider
          min={0.25}
          step={0.25}
          max={2}
          valueLabelDisplay="on"
          getAriaValueText={(value: number) => `${value ?? 1}x`}
          value={Number(responsive.getValue(props.scale)) ?? 1}
          onChange={(_, value) =>
            setProp((props) => {
              props.scale = responsive.setValue(props.scale, value);
              return props;
            })
          }
        />

        <ColorSettings
          onChange={(value: string) => {
            setProp((props: { transitionTopColor?: string; transitionBottomColor?: string }) => {
              props[`transition${position}Color`] = value === "" ? undefined : value;
              return props;
            });
          }}
          field={position === "Top" ? props.transitionTopColor : props.transitionBottomColor}
        />
      </Stack>
    </Stack>
  );
};

export default SectionTransitionSetting;
